import React, { type ReactNode } from 'react';
import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { useProject } from '@atlassian/jira-business-entity-project-hook';
import { expVal } from '@atlassian/jira-feature-experiments';
import { FormattedI18nMessage } from '@atlassian/jira-formatted-i18n-message/src/ui/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

const OpenProjectSettings = ({ children }: { children: ReactNode }) => {
	const project = useProject();

	return (
		<a href={`/jira/core/projects/${project.key}/settings/issuetypes`} target="_blank">
			{children} <ShortcutIcon label="" size="small" />
		</a>
	);
};

/**
 * @deprecated Delete this component directory when cleaning up fun-1229_board_column_header_use_workflow_store
 */
export const OpenProjectSettingsExceededIssueTypes = () => {
	const { formatMessage } = useIntl();

	return (
		<FormattedI18nMessage
			componentsMapping={{
				link: OpenProjectSettings,
			}}
			message={formatMessage(
				expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
					? messages.exceededIssueTypesBoardActionsDisabledIssueTermRefresh
					: messages.exceededIssueTypesBoardActionsDisabled,
				{
					linkStart: '{linkStart}',
					linkEnd: '{linkEnd}',
				},
			)}
		/>
	);
};
